module.exports = __webpack_public_path__ + "static/media/bootstrap.db385033.png";